import { db } from "../fb";
import { collection, addDoc, Timestamp, updateDoc, doc, getDoc, setDoc, deleteDoc } from "firebase/firestore";

// Create empty product
export const createProduct = (userId: string) => {
    const data = {
        userId,
        createdAt: Timestamp.now(),
        productId: "",
        status: "unapproved",
        shop: "dbe90d-4.myshopify.com",

    };
    // Add a new document in collection "products" with base data
    return addDoc(collection(db, "products"), data);
};

// Update product
export const updateProduct = (productId: string, data: any) => {
    // Add updateAt field
    data.updatedAt = Timestamp.now();
    return updateDoc(doc(db, "products", productId), data, { merge: true });
}

// Get user data
export const getUser = async (uid: string) => {
    const userDoc = doc(collection(db, 'users'), uid);
    const userDocSnap = await getDoc(userDoc);
    return userDocSnap.data();
};

// Update user
export const updateUser = async (uid: string, data: any) => {
    const userDoc = doc(collection(db, 'users'), uid);
    await setDoc(userDoc, data, { merge: true });
};

// Create studio data
export const createStudio = async (uid: string, studioId: string, data: any) => {
    // return addDoc(collection(db, 'users', uid, 'studio'), data);
    data.createdAt = Timestamp.now();
    return setDoc(doc(db, 'users', uid, 'studio', studioId), data);
};

// Delete studio data
export const deleteStudio = async (uid: string, studiId: string) => {
    const studioDoc = doc(collection(db, 'users', uid, 'studio'), studiId);
    return deleteDoc(studioDoc);
};

// Get slug url data
export const getSlugUrl = async (id: string) => {
    const dataDoc = doc(collection(db, 'slugUrls'), id);
    const dataDocSnap = await getDoc(dataDoc);

    return dataDocSnap.data();
};